import adproductsUtils from 'app/shared/utils/adproductsUtils';

const PropertiesReportRow = ({
    feedListingId = '',
    feedId = '',
    leadCount = 0,
    clickCount = 0,
    leaseCount = 0,
    viewCount = 0,
    daysOnMarketCount = 0,
    averageStarLevel = null,
    productTypes = [],
} = {}) => ({
    feedId: String(feedId),
    feedListingId: String(feedListingId),
    leadCount: Number(leadCount),
    clickCount: Number(clickCount),
    leaseCount: Number(leaseCount),
    viewCount: Number(viewCount),
    daysOnMarketCount: Number(daysOnMarketCount),
    averageStarLevel: averageStarLevel ? Number(averageStarLevel) : null,
    productTypes: adproductsUtils.mapProductTypes(productTypes),
});

export default PropertiesReportRow;
